const appConfig = {
    version: {
        version_code: "22",
        version_name: "4.0.3"
    }
};

export default appConfig;

